import store from '../store/index';
import api from '../services/api';
import websocket from '@/services/websocket';

export default function auth() {
  if (store.state.user.isLogged) {
    //websocket.init();
    return true;
  } else if (localStorage.getItem(store.state.storageKey) && localStorage.getItem(store.state.storageKey).length) {
    const data = {
      userData: JSON.parse(localStorage.getItem(store.state.storageKey)),
    };

    store.commit('setUser', data);

    //websocket.init();

    return true;
  } else {
    return false;
  }
  return true;
}
